<template>
    <MainContainer>
        <div class="status_stamm">
            <h2>
                Status Stammdaten
                <b-button :size="size" @click="createNew">
                    Neu
                    <font-awesome-icon icon="plus" />
                </b-button>
            </h2>
            <Table
                bordered
                striped
                small
                showFilter
                :fields="fields"
                :items="items"
                :isBusy="busy"
                sortBy="status"
                busyText="Lädt Status Stammdaten..."
                emptyText="Keine Status Stammdaten gefunden"
            >
                <template v-slot:status="{ row: row }">
                    <b-link to="/status">{{ findStatus(row.value) }}</b-link>
                </template>

                <template v-slot:beitrag="{ row: row }">
                    {{ currency(row.value) }}
                </template>

                <template v-slot:buchungskonto_id="{ row: row }">
                    {{ findBuchungskonto(row.value) }}
                </template>

                <template v-slot:ueberzahlung_buchungskonto_id_MV="{ row: row }">
                    {{ findBuchungskonto(row.value) }}
                </template>

                <template v-slot:ueberzahlung_buchungskonto_id_SP="{ row: row }">
                    {{ findBuchungskonto(row.value) }}
                </template>

                <template v-slot:beitragspflichtig="{ row: row }">
                    <template v-if="row.value == 1">
                        <font-awesome-icon icon="check" />
                    </template>
                    <template v-else>
                        <font-awesome-icon icon="times" />
                    </template>
                </template>

                <template v-slot:actions="{ row: row }">
                    <b-button
                        v-if="checkRight('write')"
                        :size="size"
                        variant="link"
                        @click="dataSelected(row)"
                        class="mv-table-action-btn mr-1"
                        >Bearbeiten</b-button
                    >
                    <b-button
                        v-if="checkRight('delete')"
                        :size="size"
                        @click="dataDelete(row)"
                        variant="link"
                        class="text-danger mv-table-action-btn"
                        >Löschen</b-button
                    >
                </template>
            </Table>
            <EditModal
                :title="selected.title"
                :busy="selected.busy"
                buttonText="Speichern"
                scrollable
                @ok="dataProvide"
                @hide="dataHide"
            >
                <template v-if="selected.data">
                    <FormGroupBuilder
                        :fields="ioFields"
                        :data="selected.data"
                        :refresh="validationRefresh"
                    />
                </template>
            </EditModal>
            <RemoveModal
                :title="selected.title"
                :busy="selected.busy"
                @ok="dataProvide"
                @hide="dataHide"
            />
        </div>
    </MainContainer>
</template>

<script>
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import Currency from "@/mixins/Currency/Currency";
import Validation from "@/mixins/Validation/Validation";
import { ApiFactory } from "@/api/ApiFactory.js";
import MainContainer from "@/components/MainContainer/MainContainer";
import Table from "@/components/Table/Table";
import EditModal from "@/components/EditModal/EditModal";
import RemoveModal from "@/components/RemoveModal/RemoveModal";
import FormGroupBuilder from "@/components/FormGroupBuilder/FormGroupBuilder";

const FibuStatusStammdatenApi = ApiFactory.get("fibuStatusStamm");
const FiBuBuchungskontoApi = ApiFactory.get("fibuBuchungskonto");
const StatusApi = ApiFactory.get("status");

export default {
    name: "FiBu_Status_Stamm",
    mixins: [CommonView, Size, Currency, Validation],
    components: {
        MainContainer,
        Table,
        EditModal,
        RemoveModal,
        FormGroupBuilder
    },
    data() {
        return {
            fields: [
                // {
                //     key: "id",
                //     value: "ID",
                //     sortable: true
                // },
                {
                    key: "status",
                    label: "Status",
                    sortable: true
                },
                // {
                //     key: "text",
                //     label: "Beschreibung",
                //     sortable: true
                // },
                {
                    key: "beitrag",
                    label: "Beitrag pro Jahr",
                    sortable: true,
                    class: "text-right"
                },
                {
                    key: "beitragspflichtig",
                    label: "Beitragspflichtig",
                    sortable: true,
                    class: "text-center"
                },
                {
                    key: "buchungskonto_id",
                    label: "Buchungskonto"
                },
                {
                    key: "ueberzahlung_buchungskonto_id_MV",
                    label: "Überbuchungskonto MV"
                },
                {
                    key: "ueberzahlung_buchungskonto_id_SP",
                    label: "Überbuchungskonto SP"
                },
                {
                    key: "actions",
                    label: "Funktionen",
                    class: "text-center"
                }
            ],
            ioFields: {
                // id: {
                //     key: "id",
                //     label: "ID",
                //     type: "text",
                //     disabled: true
                // },
                status: {
                    key: "status",
                    label: "Status",
                    type: "select",
                    options: [],
                    mandatory: true
                },
                // text: {
                //     key: "text",
                //     label: "Beschreibung",
                //     type: "text",
                //     mandatory: true
                // },
                beitrag: {
                    key: "beitrag",
                    label: "Beitrag pro Jahr",
                    type: "text",
                    mandatory: true
                },
                beitragspflichtig: {
                    key: "beitragspflichtig",
                    label: "Beitragspflichtig",
                    type: "checkbox",
                    checked_value: 1
                },
                buchungskonto_id: {
                    key: "buchungskonto_id",
                    label: "Buchungskonto",
                    type: "select",
                    options: [],
                    mandatory: true
                },
                ueberzahlung_buchungskonto_id_MV: {
                    key: "ueberzahlung_buchungskonto_id_MV",
                    label: "Überbuchungskonto MV",
                    type: "select",
                    options: [],
                    mandatory: true
                },
                ueberzahlung_buchungskonto_id_SP: {
                    key: "ueberzahlung_buchungskonto_id_SP",
                    label: "Überbuchungskonto SP",
                    type: "select",
                    options: [],
                    mandatory: true
                }
            },
            api: FibuStatusStammdatenApi,
            status: {
                busy: false,
                items: [],
                raw: []
            },
            buchungskonto: {
                busy: false,
                items: [],
                raw: []
            }
        };
    },
    watch: {
        "status.items": {
            handler(val) {
                this.ioFields.status.options = val;
            }
        },
        "buchungskonto.items": {
            handler(val) {
                this.ioFields.buchungskonto_id.options = val;
                this.ioFields.ueberzahlung_buchungskonto_id_MV.options = val;
                this.ioFields.ueberzahlung_buchungskonto_id_SP.options = val;
            }
        }
    },
    created() {
        this.fetchStatus();
        this.fetchBuchungskonto();
    },
    methods: {
        async fetchStatus() {
            this.status.busy = true;
            const response = await StatusApi.get();

            if (response.ok) {
                this.status.items = response.json.collection.map(item => {
                    return {
                        value: item.value,
                        text: `${item.value} (${item.name})`
                    };
                });
                this.status.raw = response.json.collection;
            }
            this.status.busy = true;
        },
        async fetchBuchungskonto() {
            this.buchungskonto.busy = true;
            const response = await FiBuBuchungskontoApi.get();
            if (response.ok) {
                this.buchungskonto.items = response.json.collection.map(
                    item => {
                        return {
                            value: item.id,
                            text: `${item.text} (${item.kontonr})`
                        };
                    }
                );
                this.buchungskonto.items.unshift({
                    value: null,
                    text: "Keine Auswahl"
                });
                this.buchungskonto.raw = response.json.collection;

            }
            this.buchungskonto.busy = true;
        },
        async createNew() {
          this.fetchStatus();
          this.dataCreate();
        },
        findStatus(id) {
            const result = this.status.raw.find(el => el.value === id);
            if (result) {
                return `${result.value} (${result.name})`;
            } else {
                return id;
            }
        },
        findBuchungskonto(id) {
            const result = this.buchungskonto.raw.find(el => el.id === id);
            if (result) {
                return `${result.text} (${result.kontonr})`;
            } else {
                return '-';
            }
        },
        postProcessCreate(selectedItem, response) {
            selectedItem.id = response.json.id;
            return selectedItem;
        },
        fetchErrorHandling(response) {
            this.handleValidationData(response, this.ioFields);
        },
        postDataSet() {
            this.cleanValidationData(this.ioFields);
        },
        process(item) {
            item.beitrag = item.beitrag.replace(".", ",");
            return item;
        }
    }
};
</script>
